import { toast } from "react-toastify";

export const MAX_IMAGE_MB = 1;
export const MAX_BANNER_IMAGE_MB = 3;
export const MAX_VIDEO_MB = 20;

// Returns true if the file is within the limit, otherwise shows a toast and returns false.
export const checkFileSize = (file, maxMB, label = "File") => {
  if (!file) return true;
  if (file.size > maxMB * 1024 * 1024) {
    toast.error(`${label} size should not exceed ${maxMB} MB`);
    return false;
  }
  return true;
};

// Downloads a (possibly cross-origin) file by fetching it as a blob,
// since the <a download> attribute is ignored for other origins.
export const downloadFile = async (url, fallbackName = "download") => {
  if (!url) {
    toast.error("No file to download");
    return;
  }
  const fileName = url.split("/").pop().split("?")[0] || fallbackName;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed, opening in new tab:", error);
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
